const styles = theme => ({
    root: {
        display: "flex",
        justifyContent: "center",
        marginBottom: "10px",
    },
    carousel: {
        width: "500px",
        height: "666.7px",
        [theme.breakpoints.down("sm")]: {
            width: "340px",
            height: "453.4px",
        },
    },
});

export default styles